import React from "react";
import "./Home.scss";
import user from "../../Common/JsonFiles/simran.json";
import Button from "../../Common/Button/Button";
import { AllImages } from "../../Assets/Images/AllImages";

const Home = (props) => {
  const goToContact = () => {
    props?.goToContactMeComp();
  };
  return (
    <div className={`home-main-container `}>
      <div className={`${props?.theme}`}>
        <div class="row a-i-c">
          <div class="col-10 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 info-div">
            <h1>Hi, I'm {user.name} </h1>
            <h4>{user.designation} </h4>
            <p>{user.careerObjective} </p>
            <Button name="Contact Me" onClick={() => goToContact()} />
          </div>
          <div class="col-10 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 img-div">
            {/* <div class="blob">
   <svg class="blob3" xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600"><path d="M477.2 201.2C504.4 244.7 483.6 319.3 446.1 379 408.5 438.7 354.3 483.3 293.8 486.9 233.3 490.5 166.6 453 139.9 399.6 113.2 346.2 126.5 276.8 159.8 229.8 193.2 182.7 246.6 157.8 310.8 151.6 375.1 145.3 450.1 157.7 477.2 201.2Z" fill="rgb(110, 87, 224)"/></svg> */}
            {/* <img src={AllImages.simran} alt="" /> */}
            <img src={AllImages.simran} alt="" />
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
